import { getRequiredCurrentTenantFirebase } from "../tenantBootstrap";

// Transitional boundary: current cloud transport still resolves from the
// tenant-scoped Firebase project, but the rest of the app no longer needs to
// know how that identity/config is obtained.
export const createCloudTransport = ({
  resolveTenantFirebase = getRequiredCurrentTenantFirebase,
} = {}) => ({
  getAuthenticatedInstallation() {
    const { app, auth, db, storage } = resolveTenantFirebase();

    return {
      app,
      auth,
      db,
      storage,
      installationAuthMode: "transitional-firebase-project",
    };
  },
});

export const cloudTransport = createCloudTransport();
